import { SwitchField } from '@@/form-components/SwitchField';
import { TextTip } from '@@/Tip/TextTip';
import { FormSection } from '@@/form-components/FormSection';

import { DockerSetupFormData } from './types';

interface SectionProps {
  formData: DockerSetupFormData;
  onChange: <K extends keyof DockerSetupFormData>(
    key: K,
    value: DockerSetupFormData[K]
  ) => void;
}

export function HostSection({ formData, onChange }: SectionProps) {
  return (
    <FormSection title="Host and Filesystem">
      <div className="form-group">
        <div className="col-sm-12">
          <TextTip className="mb-2">
            The environment must be{' '}
            <a href="https://docs.portainer.io/start/agent">
              running the Portainer Agent
            </a>{' '}
            to use this functionality, and the root of the host must be
            bind-mounted to <strong>/host</strong> in the agent deployment.
            Check{' '}
            <a href="https://docs.portainer.io/user/docker/host/setup#enable-host-management-features">
              our documentation
            </a>{' '}
            for more information.
          </TextTip>
        </div>
      </div>

      <div className="form-group">
        <div className="col-sm-12">
          <SwitchField
            checked={formData.enableHostManagementFeatures}
            onChange={(value) =>
              onChange('enableHostManagementFeatures', value)
            }
            label="Enable host management features"
            tooltip="Enable host management features: host system browsing and advanced host details."
            labelClass="col-sm-7 col-lg-4"
            data-cy="enable-host-management-switch"
          />
        </div>
      </div>

      <div className="form-group">
        <div className="col-sm-12">
          <SwitchField
            checked={formData.allowVolumeBrowserForRegularUsers}
            onChange={(value) =>
              onChange('allowVolumeBrowserForRegularUsers', value)
            }
            label="Enable volume management for non-administrators"
            tooltip="When enabled, regular users will be able to use Portainer volume management features."
            labelClass="col-sm-7 col-lg-4"
            data-cy="allow-volume-browser-switch"
          />
        </div>
      </div>
    </FormSection>
  );
}
